// extracted by mini-css-extract-plugin
module.exports = {"base":"collectionNameTabs-m__base__SHJM9","en-headline":"collectionNameTabs-m__en-headline__3IS8H","bn-headline":"collectionNameTabs-m__bn-headline__17FpV"};